"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const breadcrumb_group_1 = __importDefault(require("@amzn/awsui-components-react/polaris/breadcrumb-group"));
function Breadcrumbs({ items }) {
    return (0, jsx_runtime_1.jsx)(breadcrumb_group_1.default, { items: items });
}
exports.Breadcrumbs = Breadcrumbs;
